// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from './base-entity';
import { ApplicationUser } from './application-user';
import { Country } from './country';
import { Equipment } from './equipment';
import { PurchaseTransaction } from './purchase-transaction';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export class Supplier extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  supplierId: number;
  airCode: string;
  applicationUserId: string;
  countryId: number;
  createdOn: Date;
  modifiedOn: Date;
  supplierLocation: string;
  supplierMobile: string;
  supplierName: string;
  supplierPhone: string;
  website: string;
  applicationUser: ApplicationUser;
  country: Country;
  equipments: Equipment[];
  purchaseTransactions: PurchaseTransaction[];
}

